import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { studentDashboard } from '@app-constants/app.constants';
import {environment} from '@app-environments/environment';
import {surgedata} from '@app-services/IL-syllabus/surge-data';

@Component({
  selector: 'app-course-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class courseHeaderComponent implements OnInit {
  successHome= environment?.successHome;
  surgeData = surgedata;
  constructor(private router: Router, private route: ActivatedRoute) { }
  homeRoute = studentDashboard
  openSidebar = false
  @Input('color') public color
  ngOnInit(): void {
    console.log(this.color)
  }
  user = localStorage.getItem('token')
  gotoDashboard(){
    if(this.user){
      this.router.navigate(['/dashboard'])
    } else{
      window.location.href = studentDashboard
    }
  }

  navigateToSignIn(){
    this.route.queryParams.subscribe(params => {
      if(params?.tenant  == 'iltsc') {
        this.router.navigate(['/signin'], { queryParams: { tenant: 'iltsc'} })
      } else {
        this.router.navigate(['/signin']);
      }
    })
  }

  showExams(a){
    $('#exams' + a).toggleClass('show');
  }
  showClass(b){
    $('#urls' + b).toggleClass('show');
  }

}
